// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202610082135/js/" + chunkId + "." + {"44":"4b899afb","225":"fb5ed7cf","481":"a5cc342c","486":"f4cd9127","770":"66b050eb"}[chunkId] + ".0.9088991219877536.chunk.js";
};